import {HttpInterceptorFn, HttpErrorResponse} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {environment} from "../../../environments/environment";
import {inject} from "@angular/core";
import {CustomerService} from "../../customer/services/customer.service";

export const minizaemApiResponseInterceptor: HttpInterceptorFn = (req, next) => {
  const customerService = inject(CustomerService);

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      if (req.url.includes(environment.minizaemApiDomain) && response.status === 401 || response.status === 403) {
        customerService.logout();
      }

      return throwError(() => response.error + response.message);
    })
  );
};
